import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from 'app/global-services/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, of, Subject, takeUntil } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import {
    AMPLITUDE_EVENT_CATEGORIES,
    AMPLITUDE_EVENTS,
    AmplitudeEvent,
    AmplitudeService,
} from '../../global-services/amplitude.service';
import { INSTALL_CTA_SOURCE } from '../../shared/utils';
import { environment } from '../../../environments/environment';

@Component({
    templateUrl: 'mob-landing-page.component.html',
    styleUrls: ['mob-landing-page.component.scss'],
    standalone: false
})
export class MobLandingPageComponent implements OnInit, OnDestroy {
    isIOS: boolean = false;
    deviceOs: string;

    ngUnsubscribe: Subject<any> = new Subject();

    constructor(
        private authService: AuthService,
        private deviceDetectorService: DeviceDetectorService,
        private changeDetectorRef: ChangeDetectorRef,
        private amplitude: AmplitudeService
    ) {}

    showDeviceSpecificButtons(): Observable<void> {
        return of(null).pipe(
            switchMap(() => {
                let isMobile = this.deviceDetectorService.isMobile();
                if (isMobile) {
                    this.isIOS =
                        this.deviceDetectorService.getDeviceInfo().os === 'iOS';
                }
                return of(null);
            })
        );
    }

    ngOnInit() {
        this.showDeviceSpecificButtons().subscribe(() => {
            this.changeDetectorRef.markForCheck();
        });
        this.logEventOnRender();

        this.getDeviceOs();
    }

    getDeviceOs() {
        this.authService.checkDeviceOs$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((deviceOs) => {
                this.deviceOs = deviceOs;
            });
    }

    redirectToMobileApp() {
        const event = new AmplitudeEvent();
        event.eventName = AMPLITUDE_EVENTS.CARD_MOBILE_APP_INSTALL_CLICKED;
        event.properties = {
            device: this.deviceOs,
            source: INSTALL_CTA_SOURCE.MYCARDS_LANDING_PAGE,
        };
        this.logAmplitudeEvent(AMPLITUDE_EVENT_CATEGORIES.Usage, event);

        window.location.href = environment.mobileAppChotuLink;
    }

    logEventOnRender() {
        const event = new AmplitudeEvent();
        event.eventName = AMPLITUDE_EVENTS.MYCARDS_LANDING_PAGE_OPENED_MOBILE;
        event.properties = {
            opened_as: this.amplitude.setAmplitudeEventProperties(),
            device_type: this.amplitude.setDeviceProperties(),
        };
        this.logAmplitudeEvent(AMPLITUDE_EVENT_CATEGORIES.Usage, event);
    }

    logAmplitudeEvent(
        type: AMPLITUDE_EVENT_CATEGORIES,
        event: AmplitudeEvent
    ): void {
        this.amplitude.logEvent(type, event.eventName, event.properties);
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
    }
}
